module.exports = __webpack_public_path__ + "img/ai-weapon5.e88fc77b.png";